import GfCompleteOrder from '@/gf/components/CompleteOrder'
import useMsgs from '@/gf/hooks/useMsgs'
import { useCompleteOrderQuery, useOrderCompletedMutation } from '@/suppliers/_gen/gql'
import useGqlClient from '@/suppliers/hooks/useGqlClient'
import { useNavigate } from 'react-router-dom'

const CompleteOrder = ({
  storeOrderId,
  onCompleted,
}: {
  storeOrderId: string
  onCompleted: () => void
}) => {
  const [_, msgr] = useMsgs()
  const client = useGqlClient()
  const [orderCompleted] = useOrderCompletedMutation({ client })
  const navigate = useNavigate()
  const { data, refetch } = useCompleteOrderQuery({ variables: { id: storeOrderId }, client })
  const storeOrder = data?.storeOrder

  if (!storeOrder) return null

  const close = () => navigate(`/orders/${storeOrder.id}`)

  const submit = async () => {
    await orderCompleted({ variables: { storeOrderId: storeOrder.id } })
    refetch()
    onCompleted()
    msgr.add('Order completed.', 'positive')
  }

  const shippedQtyByLineItemId = storeOrder.shipments.reduce<Record<string, number>>(
    (acc, shipment) =>
      (shipment.shipmentItems || []).reduce(
        (subAcc, item) => ({
          ...subAcc,
          [item.lineItemId]: (subAcc[item.lineItemId] || 0) + item.quantity,
        }),
        acc
      ),
    {}
  )

  const unshippedItems = storeOrder.lineItems
    .map((li) => {
      const unshippedQty = li.quantity - (shippedQtyByLineItemId[li.id] || 0)
      return { ...li, unshippedQty }
    })
    .filter((li) => li.unshippedQty > 0)

  return <GfCompleteOrder unshippedItems={unshippedItems} submit={submit} close={close} />
}

export default CompleteOrder
